import { render, staticRenderFns } from "./ReferralProgramOwners.vue?vue&type=template&id=571171d2&scoped=true&"
import script from "./ReferralProgramOwners.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramOwners.vue?vue&type=script&lang=js&"
import style0 from "./ReferralProgramOwners.vue?vue&type=style&index=0&id=571171d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571171d2",
  null
  
)

export default component.exports